import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import ServiceCarousel, { EVENT_SERVICES } from "@/components/storefront/ServiceCarousel";
import SEO from "@/components/SEO";

export default function EventServices() {
    return (
        <div className="xp-services-page">
            <SEO title="Event Services" description="Explore corporate events, weddings, exhibitions, catering, MICE and brand activations by X-Plosiv." />
            <section className="xp-services-page__hero">
                <p>ONE CREATIVE PARTNER. EVERY DETAIL.</p>
                <h1>Services that make<br /><em>the moment.</em></h1>
                <span>Choose an event type to explore real occasion stories, event details and photo libraries curated by X-Plosiv.</span>
            </section>
            <section className="xp-services-page__carousel">
                <div className="xp-wrap">
                    <div className="xp-section-heading">
                        <div><p className="xp-label"><span />A LITTLE DIFFERENT, EVERY TIME</p><h2>Find your kind<br /><em>of occasion.</em></h2></div>
                        <p>From the first idea to the final cue, we bring the right creative, production and people together.</p>
                    </div>
                    <ServiceCarousel />
                </div>
            </section>
            <section className="xp-services-page__list xp-wrap">
                <div><p className="xp-label"><span />ALL THE MOVING PARTS</p><h2>Choose an event<br />to explore.</h2></div>
                <div className="xp-services-page__rows">
                    {EVENT_SERVICES.map((service) => (
                        <Link key={service.number} to={`/services/${service.slug}`}>
                            <span>{service.number}</span><strong>{service.title}</strong><small>{service.copy}</small><ArrowRight size={17} />
                        </Link>
                    ))}
                </div>
            </section>
            <section className="xp-services-page__close"><Sparkles size={19} /><p>Have an idea that doesn’t fit a category?</p><Link to="/contact">Let’s talk about it <ArrowRight size={15} /></Link></section>
        </div>
    );
}
